<template>
  <div>
    <h1 class="h3">Reviews</h1>
    <p class="p">Here is where you can review procedures submitted by patients.</p>
    <module-button
      class="mt0 mb"

      button="primary"
      size="m"
      label="Start Reviewing"
      @click.native="startReviewing"
    />
  </div>
</template>

<script>
// Modules
import ModuleButton from 'modules/Button';

// Export
export default {
  name: `ui-dashboard-reviews`,

  // Components
  components: {
    ModuleButton,
  },

  methods: {
    startReviewing() {
      this.$router.push({
        name: `dashboard-next-review`,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Reviews.vue?4ae8a4ca